import { motion } from 'framer-motion';
import CryoneBanner from '../organisms/ProjectsList/CryoneProject/CryoneBanner';
import CryoneProjectOverview from '../organisms/ProjectsList/CryoneProject/CryoneProjectOverview';
import CryoneObjective from '../organisms/ProjectsList/CryoneProject/Cryone_challenge';
import CryoneSolutions from '../organisms/ProjectsList/CryoneProject/Cryone_whatwebuild';
import CryoneDream from '../organisms/ProjectsList/CryoneProject/CryoneOutcome';
import CryoneDetails from '../organisms/ProjectsList/CryoneProject/CryoneFeatures';
import AppsTestimonials from '../molecules/AppsTestimonials/AppsTestimonials';
import CompanyLogoImage from '../molecules/CompanyLogoImage/CompanyLogoImage';
import ContactHelp from '../molecules/ContactHelp/ContactHelp';
import Footer from '../organisms/Footer/Footer';
import { getPageData, useData } from '../../app/helper/functions';

const CryonePage = () => {
    const { data } = useData();
    const cryoneProject = getPageData(data, 'cryoneProjectPage');

    return (
        <div className='bg-[#141414] overflow-x-hidden relative'>
            <CryoneBanner cryoneProject={cryoneProject} />
            <div>
                <CryoneProjectOverview cryoneProject={cryoneProject} />
                <CryoneObjective cryoneProject={cryoneProject} />
                <CryoneSolutions cryoneProject={cryoneProject} />
                <CryoneDream cryoneProject={cryoneProject} />
                <CryoneDetails cryoneProject={cryoneProject} />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <AppsTestimonials color="#FF3333" bgcolor={"bg-[#FF3333]"} textColor='black' activeTextColor='white' />
            </motion.div>

            <motion.div
                className='p-4 sm:p-6 md:p-10 px-4 sm:px-16 md:px-36'
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <CompanyLogoImage bgColor='bg-[#222222]' borderColor='border-[#2A2A2A]' />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
                className="px-4 sm:px-0"
            >
                <ContactHelp title={cryoneProject?.cryoneProjectDetails?.contactHelpTitle} buttonTitle={cryoneProject?.cryoneProjectDetails?.contactHelpButtonTitle} />
            </motion.div>

            <Footer />
        </div>
    );
};

export default CryonePage;
